import { styled } from 'styled-components';

export const InnerWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-top: var(--spacing-small);
`;
